export var messageActionDefaultTheme = {
  Root: {
    base: {
      fontFamily: '$typography.paragraphMedium.fontFamily',
      color: '$color.primary.main',
      fontWeight: '$typography.paragraphMedium.fontWeight',
      fontSize: '$typography.paragraphMedium.fontSize'
    }
  }
};